import { forwardRef, useEffect, useState } from 'react';
import type { VisualizationData } from '../../types';
import { Visualization } from '../visualization/Visualization';

interface PdfRendererProps {
  visualization: VisualizationData | null;
  onReady?: () => void;
}

export const PdfRenderer = forwardRef<HTMLDivElement, PdfRendererProps>(
  function PdfRenderer({ visualization, onReady }, ref) {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
      if (visualization) {
        // Wait for the chart to render before signaling ready
        const timer = setTimeout(() => {
          setIsReady(true);
          onReady?.();
        }, 500);

        return () => clearTimeout(timer);
      }
    }, [visualization, onReady]);

    if (!visualization) {
      return null;
    }

    return (
      <div
        ref={ref}
        style={{
          position: 'fixed',
          left: '-9999px',
          top: 0,
          width: '600px',
          height: '400px',
          backgroundColor: '#ffffff',
          padding: '16px',
          overflow: 'hidden',
          zIndex: -1,
        }}
        aria-hidden="true"
      >
        <div
          data-pdf-chart
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#ffffff',
          }}
        >
          <Visualization data={visualization} animated={false} />
        </div>
        {isReady && (
          <div data-pdf-ready style={{ display: 'none' }}>
            ready
          </div>
        )}
      </div>
    );
  }
);
